export function diffUsers(users) {
  return users.reduce(
    (obj, user) => {
      const { role } = user;
      obj[role] = obj[role] ? [...obj[role], user] : [user];
      return obj;
    },
    { broker: [], manager: [], borrower: [] }
  );
}

export function diffAccount(accounts) {
  return accounts.reduce(
    (obj, account) => {
      const { type } = account;
      obj[type] = obj[type] ? [...obj[type], account] : [account];
      return obj;
    },
    { brokers: [], managers: [], borrowers: [] }
  );
}

export function createAccountList(accounts, role) {
  const type = role + 's';
  const accountList = [];
  const mArray = accounts[type].filter(i => i.type === type);
  mArray.forEach(i => {
    accountList.push({ value: i.id, label: i.name });
  });
  return accountList;
}

export function createUserList(users) {
  return {
    borrowerList: users['borrower'].map(i => ({ value: i.id, label: i.first_name + ' ' + i.last_name })),
    managerList: users['manager'].map(i => ({ value: i.id, label: i.first_name + ' ' + i.last_name })),
    brokerList: [
      { value: '', label: 'No Broker' },
      ...users['broker'].map(i => ({ value: i.id, label: i.first_name + ' ' + i.last_name }))
    ]
  };
}
